// extracted by mini-css-extract-plugin
export default {"container":"AccessDeniedPage_container__sWJQ5","goToRegistryBtn":"AccessDeniedPage_goToRegistryBtn__E27qc","actionsBlock":"AccessDeniedPage_actionsBlock__Uj0HL"};